import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getSkuConfigurationDataAsync } from 'src/services/shouldCostAIBased.services'

const initialState = {
  getConfigurationLoader: false,
  getConfigurationData: {
    l1: 'L1',
    l2: 'L2',
    l3: 'L3',
    primary_id: 'Primary Id',
    secondary_id: 'Secondary Id',
  },
  getConfigurationError: '',
}

export const configurationSlice = createSlice({
  name: 'get-config-data',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getSkuConfigurationDataAsync.pending), (state) => {
      state.getConfigurationLoader = true
    })
    builder.addMatcher(isAnyOf(getSkuConfigurationDataAsync.fulfilled), (state, action) => {
      state.getConfigurationLoader = false

      // Transform the array of objects into the desired format
      const configData = action.payload.data?.reduce((acc, { key, value }) => {
        acc[key] = value
        return acc
      }, {})

      state.getConfigurationData = {
        primary_id: configData.primary_id || initialState.getConfigurationData.primary_id,
        secondary_id: configData.secondary_id || initialState.getConfigurationData.secondary_id,
        l1: configData.l1 || initialState.getConfigurationData.l1,
        l2: configData.l2 || initialState.getConfigurationData.l2,
        l3: configData.l3 || initialState.getConfigurationData.l3,
      }
    })
    builder.addMatcher(isAnyOf(getSkuConfigurationDataAsync.rejected), (state, action) => {
      state.getConfigurationLoader = false
      state.getConfigurationError = action.payload.message
    })
  },
})

export default configurationSlice.reducer
